import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { MultiButtonModal } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { hasReadTimeOutError } from '../../states/page/selectors';
import { resetApp } from '../../states/page/actions';
import withContent from '../../containers/withContent';
import pageContent, { contentPropTypes } from './index.content';

const mapState = (state) => ({
	readTimeOutError: hasReadTimeOutError(state),
});

const mapDispatch = (dispatch) => ({
	resetApp: () => {
		dispatch(resetApp);
	},
});

export const PaymentTimedOutModal = ({ resetApp, readTimeOutError, content, handleRoute }) => {
	const { paymentTimedOutModalTitle, paymentTimedOutInfoText, paymentStatusInfoText } = content;

	const handleClose = () => {
		resetApp();
		handleRoute('WEB-HOMEPAGE');
	};

	return (
		<MultiButtonModal
			titleText={paymentTimedOutModalTitle}
			onClose={handleClose}
			isOpen={readTimeOutError}
			buttons={[]}
		>
			<StandardBody>
				<p>
					<strong>{paymentTimedOutInfoText}</strong>
				</p>
				<p>{paymentStatusInfoText}</p>
			</StandardBody>
		</MultiButtonModal>
	);
};

PaymentTimedOutModal.propTypes = {
	handleRoute: PropTypes.func.isRequired,
	content: PropTypes.shape(contentPropTypes).isRequired,
	resetApp: PropTypes.func.isRequired,
	readTimeOutError: PropTypes.bool.isRequired,
};

export default compose(connect(mapState, mapDispatch), withContent({ content: pageContent }))(PaymentTimedOutModal);
